/*
 * PROMIXX link click tracking.
 *
 * Publishes a `pmx_link_click` customer event for every link click. The
 * link-click-pixel extension (promixx-bundle-discount app) forwards it to GA4.
 * Nothing is sent without analytics consent (the pixel handles that).
 *
 * Label a link explicitly with data-pmx-track="name"; otherwise the id is
 * derived from the section it sits in plus its text or path.
 */
(function () {
  if (window.__pmxLinkTracking) return;
  window.__pmxLinkTracking = true;

  var page = window.PMX_PAGE || {};

  function slug(str) {
    return String(str || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60);
  }

  // Section wrapper ids look like "shopify-section-sections--123__header" or
  // "shopify-section-template--123__pmx_bundle_picks_x8Qw": keep the key.
  function sectionOf(el) {
    var region = el.closest('[data-pmx-track-region]');
    if (region) return region.getAttribute('data-pmx-track-region');
    var wrapper = el.closest('[id^="shopify-section-"]');
    if (wrapper) return sectionKey(wrapper.id.replace('shopify-section-', '').split('__').pop());
    if (el.closest('header')) return 'header';
    if (el.closest('footer')) return 'footer';
    return 'page';
  }

  // Theme-editor keys end in a random 6-char suffix ("image_banner_style_1_BhxiTp"):
  // drop it so the label reads as the section type.
  function sectionKey(key) {
    var m = key.match(/^(.+)_([A-Za-z0-9]{6})$/);
    if (m && /[a-z]/.test(m[2]) && /[A-Z0-9]/.test(m[2])) return m[1];
    return key;
  }

  // Join text nodes with spaces so adjacent spans don't run together
  // ("Bundle & Save" + "Find your bundle").
  function textOf(el) {
    var parts = [];
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) parts.push(walker.currentNode.nodeValue);
    return parts.join(' ');
  }

  // Ratings and review counts change over time; keep them out of the id.
  function stableText(text) {
    return text
      .replace(/\d(\.\d)?\s*[·•|-]?\s*\(?[\d,]+\)?\s*reviews?/gi, '')
      .replace(/\(?[\d,]+\)?\s*reviews?/gi, '');
  }

  function linkText(el) {
    var text = (el.getAttribute('aria-label') || textOf(el) || '').replace(/\s+/g, ' ').trim();
    if (!text) {
      var img = el.querySelector('img[alt]');
      if (img) text = img.getAttribute('alt');
    }
    return text.slice(0, 100);
  }

  document.addEventListener(
    'click',
    function (e) {
      var el = e.target.closest('a[href], [data-pmx-track]');
      if (!el) return;
      var href = el.getAttribute('href') || '';
      if (el.tagName === 'A' && (!href || href.charAt(0) === '#' || href.indexOf('javascript:') === 0)) {
        if (!el.hasAttribute('data-pmx-track')) return;
      }

      var url;
      try {
        url = href ? new URL(href, window.location.href) : null;
      } catch (err) {
        url = null;
      }
      var internal = url && url.host === window.location.host;
      var path = url ? (internal ? url.pathname + url.search : url.href) : '';
      var section = sectionOf(el);
      var text = linkText(el);
      var id = el.getAttribute('data-pmx-track') || section + ':' + (slug(stableText(text)) || slug(path) || 'link');

      var payload = {
        link_id: id,
        link_text: text,
        link_url: path,
        link_section: section,
        page_type: page.template || page.type || '',
        is_bundle_link: /bundle/i.test(path),
      };

      try {
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          Shopify.analytics.publish('pmx_link_click', payload);
        }
      } catch (err) {
        /* tracking must never block navigation */
      }
    },
    true
  );
})();
